module.exports = __webpack_public_path__ + "img/ylb-1.eaf88b07.png";